import { render, staticRenderFns } from "./CustomerProfileLayout.vue?vue&type=template&id=28318b20&scoped=true&"
import script from "./CustomerProfileLayout.vue?vue&type=script&lang=js&"
export * from "./CustomerProfileLayout.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProfileLayout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerProfileLayout.vue?vue&type=style&index=1&id=28318b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28318b20",
  null
  
)

component.options.__file = "CustomerProfileLayout.vue"
export default component.exports